import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { SUPPORT_ROLES } from 'common/utils/user';

export const SITE_ALERTS_PATH = '/sitealerts/:studyId/:alertId?';
export const SITE_ALERTS_LEGACY_PATH = '/alerts/:studyId/:alertId?';

export const routes = [
    {
        component: lazy(() => import('module/studysitealerts/SiteAlertsPage')),
        permissions: [],
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        path: SITE_ALERTS_PATH,
    },
    {
        component: lazy(() => import('module/studysitealerts-legacy/studysitealerts.page')),
        permissions: [],
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        path: SITE_ALERTS_LEGACY_PATH,
    },
];
